<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">
        No data for "Current State of Health" chart.
    </rb-callout>
</div>
<div id="current-sohc-chart"></div>
<div class="p-2" *ngIf="!dataLoading && !errorMessage">
    <div class="shaded-container">
        Distribution of current State of Health values for your fleet. The values are given as a percentage of the whole fleet.
    </div>
</div>